export const XS = 5;
export const SM = 10;
export const MD = 15;
export const LG = 20;
export const XL = 30;
